import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Link, Text } from 'components/ui';
import InfoButton from 'components/InfoButton/InfoButton';
import { globalModals, renderModal } from 'utils/globalModals';
const { FEDEX_PICKUP_LOCATION_INFO } = globalModals;
import bccUtils from 'utils/BCC';
const { ACCESS_POINT_INFO_MODAL } = bccUtils.MEDIA_IDS;
import Radio from 'components/Inputs/Radio/Radio';

const infoModalOptions = {
    isOpen: true,
    mediaId: ACCESS_POINT_INFO_MODAL,
    titleDataAt: 'accessPointInfoModalTitle'
};

function AccessPointButtonView({
    title, moreInfoLabel, showInfoModal, accessPointHandler, label, hideInfoButton, topMargin = false
}) {
    return (
        <Box marginTop={topMargin && 4}>
            {title && (
                <Box>
                    <Text
                        key='title'
                        fontWeight='bold'
                        children={title}
                        marginRight={1}
                    />{' '}
                    <InfoButton
                        aria-label={moreInfoLabel}
                        size={16}
                        onClick={showInfoModal}
                    />
                </Box>
            )}
            <Link
                color='blue'
                display='inline'
                marginRight={1}
                children={label}
                {...(accessPointHandler && { onClick: accessPointHandler })}
            />
            {!hideInfoButton && !title && (
                <InfoButton
                    aria-label={moreInfoLabel}
                    size={16}
                    onClick={showInfoModal}
                />
            )}
        </Box>
    );
}

function AccessPointButton({
    label,
    title,
    accessPointHandler,
    infoModalTitle,
    showMediaModal,
    globalModalsProp,
    moreInfoLabel,
    isHal,
    fireInfoModalAnalytics,
    isRadio = false
}) {
    const modalData = {
        ...globalModalsProp[FEDEX_PICKUP_LOCATION_INFO],
        title: infoModalTitle,
        isDrawer: true
    };

    const showInfoModal = event => {
        event.preventDefault();
        event.stopPropagation();

        renderModal(modalData, () => {
            showMediaModal(infoModalOptions);
            fireInfoModalAnalytics();
        });
    };

    return (
        <>
            {isRadio ? (
                <Radio
                    name='shipAddressOption'
                    onClick={accessPointHandler}
                    paddingY={0}
                    dotOffset={0}
                    alignItems='flex-start'
                    width='100%'
                >
                    <AccessPointButtonView
                        title={title}
                        moreInfoLabel={moreInfoLabel}
                        showInfoModal={showInfoModal}
                        label={label}
                    />
                </Radio>
            ) : (
                //Not selected, not changing addresses
                <AccessPointButtonView
                    title={title}
                    moreInfoLabel={moreInfoLabel}
                    showInfoModal={showInfoModal}
                    accessPointHandler={accessPointHandler}
                    label={label}
                    hideInfoButton={isHal}
                    topMargin
                />
            )}
        </>
    );
}

export default wrapFunctionalComponent(AccessPointButton, 'AccessPointButton');
